// Audio Player with second buttons

import { useState, useRef, useEffect, useCallback } from 'react';
import retryimg from "../img/retry_white.svg";
import checkmarkicon from "../img/checkmarkcircle.svg";
import pauseicon from "../img/pause_dark.svg";
import Confetti from 'react-confetti';

import { toGameDocumentUrl } from '../functions/contentUrls';
import { translate } from '../functions/translationHelper';


function ContentGame(props) {
  const { content, baseurl, language, onCompletion, showButtons } = props;
  const iframeSrc = content?.external
    ? content.url
    : toGameDocumentUrl(`${baseurl || ''}${content?.url || ''}`);

  const [overlayopen, setOverlayopen] = useState(true);
  const [finished, setFinished] = useState(false);
  const [finishedFromMessage, setFinishedFromMessage] = useState(false);
  const [showConfetti, setShowConfetti] = useState(false);
  const [confettiKey, setConfettiKey] = useState(0);

  const iframeref = useRef(null);
  const resetFinishedMessageTimeoutRef = useRef(null);
  
  const stop = useCallback((fromMessage = false) => {
    setFinished(true);
    setFinishedFromMessage(fromMessage);
    if (fromMessage) {
      setConfettiKey((prev) => prev + 1);
      setShowConfetti(true);
    }
    onCompletion();
    setOverlayopen(true);
    showButtons?.(true);
  }, [onCompletion, showButtons]);

  const handleMessage = useCallback((event) => {
    if (event.source !== iframeref.current?.contentWindow) {
      return;
    }

    if (event.data === 'finish') {
      stop(true);
    }
  }, [stop]);

  useEffect(() => {
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
      if (resetFinishedMessageTimeoutRef.current) {
        clearTimeout(resetFinishedMessageTimeoutRef.current);
      }
    };
  }, [handleMessage]);

  function start() {
    setShowConfetti(false);
    if (resetFinishedMessageTimeoutRef.current) {
      clearTimeout(resetFinishedMessageTimeoutRef.current);
    }
    resetFinishedMessageTimeoutRef.current = setTimeout(() => {
      setFinishedFromMessage(false);
    }, 300);
    showButtons?.(false);
    iframeref.current?.contentWindow?.postMessage('reload', '*');
    setOverlayopen(false);
  }

  /*
  useEffect(() => {
    if (!props.active) {
      
    }
  }, [props.active])
  */

  return (
    <div className="page-content-game">
      {showConfetti && (
        <Confetti
          key={confettiKey}
          numberOfPieces={100}
          recycle={false}
          style={{ zIndex: 4 }}
          onConfettiComplete={(confetti) => {
            confetti?.reset();
            setShowConfetti(false);
          }}
        />
      )}
      <div className='stopgamebutton clickable' onClick={() => stop(false)}><img src={pauseicon} /></div>
      <div className={`content-game-overlay ${!overlayopen && "content-game-overlay-closed"}`}>
        <div className='wrapper'>
          {finishedFromMessage ? (
              <>
              <img src={checkmarkicon} style={{ width: 48, marginBottom: 12 }} />
              <h2 style={{marginBottom: 24}}>{translate("game_madeit", language)}</h2>
              </>
          ) : (
            <>
              <h2>{content?.title}</h2>
              <p>{content?.description}</p>
            </>
          )}
          {!finished && <div className='button-primary' onClick={() => start()}>{translate("startnow", language)}</div>}
          {/*finished ? <div className='button-primary' onClick={() => props.onNext()}>{translate("next", language)}</div> : <div className='button-primary' onClick={() => start()}>{translate("startnow", language)}</div>*/}
          {finished && <div className='button-secondary button-secondary-light  clickable' onClick={() => start()}><img src={retryimg} style={{ width: 20, marginRight: 4 }} />{translate("startagain", language)}</div>}
        </div>
      </div>

      <iframe
        ref={iframeref}
        src={iframeSrc}
        title={content?.title || 'Game'}
      />
    </div>
  );
}

export default ContentGame;
